import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import React from "react";

import { useLocalStorage } from "../../../hooks";

import { XMarkIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import marker from "../../../assets/location.svg";
import { TwButton, TwInputGroup, TwPhoneInputGroup, TwSelectGroup } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForEvent } from "../../../utils/confighelpers";
import email_img from "../../../assets/Email.svg";
import institute_img from "../../../assets/Institute.svg";
import { isValidEmail } from "../../../helpers";
import { useTranslation } from "react-i18next";


export default function IssueFreeTicketModal({
  eventScheduleId,
  eventScheduleData,
  open,
  handleClose,
  reload,
}) {
  const { t, i18n } = useTranslation();
  const { addErrorToast, addSuccessToast, addNotificationDialog } = useToast();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const defaultData = {
    consumerUsername: "",
    consumerFullname: "",
    consumerEmail: "",
    mobile: "",
    quantity: 1,
    ticket: "",
    selectedEventPricing: [],
  }
  const [formValues, setFormValues] = React.useState({
    ...defaultData,
  });
  const [formErrors, setFormErrors] = React.useState({});

  const validateData = () => {
    const errors = {};
    if (!formValues.ticket || formValues.ticket === "" || formValues.ticket == "") {
      errors.ticket = t("errors.required");
    }

    if (formValues.quantity === "" || formValues.quantity <= 0) {
      errors.quantity = t("myEvents.enterAtLeastOneQuantity");
    }
    if (formValues.quantity % 1 !== 0) {
      errors.quantity = t("errors.decimalValueOnly");
    }
    
    let ticketDetail = JSON.parse(formValues?.ticket || "{}")
    if (ticketDetail && ticketDetail?.capacity != undefined && ticketDetail?.ticketsBooked && ticketDetail.ticketsBooked.ticketsBookedConfirmed != undefined && parseInt(ticketDetail.capacity) <= parseInt(ticketDetail.ticketsBooked.ticketsBookedConfirmed)) {
      errors.quantity = t("myEvents.reachedItsMaxCapacity");
    } else if (formValues.quantity && ticketDetail && ticketDetail?.capacity != undefined && ticketDetail?.ticketsBooked && ticketDetail.ticketsBooked.ticketsBookedConfirmed != undefined && parseInt(ticketDetail.capacity) <= parseInt(parseInt(ticketDetail.ticketsBooked.ticketsBookedConfirmed) + parseInt(formValues.quantity))) {
      errors.quantity = t("myEvents.reachedItsMaxCapacity");
    }

    if (!formValues.consumerFullname) {
      errors.consumerFullname = t("errors.required");
    }

    if (!formValues.consumerEmail) {
      errors.consumerEmail = t("errors.required");
    } else if (formValues.consumerEmail.length > 0 && isValidEmail(formValues.consumerEmail) === false) {
      errors.consumerEmail = t("errors.enterValidEmail");
    }

    if (!formValues.consumerUsername) {
      errors.mobile = t("errors.required");
    }
    if (!formValues.mobile) {
      errors.mobile = t("errors.required");
    }

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return false;
    }
    return true;
  };

  const orderPlace = async () => {

    if (validateData()) {
      let ticket = JSON.parse(formValues.ticket);
      let body = {
        eventScheduleId: eventScheduleId,
        consumerFullname: formValues.consumerFullname,
        consumerUsername: formValues.consumerUsername,
        consumerEmail: formValues.consumerEmail,
        selectedEventPricing: [
          {
            ticketType: ticket.ticketType,
            bookingQty: parseInt(formValues.quantity),
          }
        ],
        // quantity: parseInt(formValues.quantity),
        isComplementaryTicket: true,
        paymentMethod: "free",
        utcOffset: 0
      }

      // return;

      const config = {
        method: "post",
        url: `${getUrlForEvent()}payments/orderPlace`,
        data: body,
      };

      dispatch(setGlobalLoading(true));
      dispatch(setActionLoading(true));
      const orderPlaceRequest = await axiosInstance(config);
      dispatch(setGlobalLoading(false));
      dispatch(setActionLoading(false));
      if (orderPlaceRequest.data.statusCode === 200) {
        if (orderPlaceRequest.data.message) {
          addSuccessToast(orderPlaceRequest.data.message);
        }
        handleClose();
        setFormValues({
          ...defaultData,
        })
        reload();
      } else if (orderPlaceRequest.data.statusCode !== 200) {
        if (orderPlaceRequest.data.statusCode === 500) {
          addErrorToast(orderPlaceRequest.data.message);
          return;
        } else if (orderPlaceRequest.data.message) {
          // addErrorToast(orderPlaceRequest.data.message);
          setFormErrors({ ticket: orderPlaceRequest.data.message });
          //   }
          // })
        }
        return;
      }
    } else {
      return;
    }
  };


  return (
    <Dialog
      open={open}
      onClose={() => {
        // setFormValues({
        //   ...defaultData,
        // })
        // handleClose();
      }}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-md sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <div className="flex flex-col gap-4">
              <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                {t("myEvents.issueComplementaryTicket")}
              </DialogTitle>
              <TwSelectGroup
                label={t("myEvents.selectTicket")}
                placeholder={t("myEvents.selectTicket")}
                name={"ticket"}
                // leftIcon={<img className="size-5" src={ticketStarIcon} />}
                options={[
                  { value: "", title: t("myEvents.selectTicket") },
                  ...[...(eventScheduleData?.eventPricingList || [])].map((item) => {
                    return {
                      value: JSON.stringify(item),
                      // value: (item),
                      title: item?.ticketType
                    }
                  })
                ]}
                defaultValue={formValues.ticket}
                value={formValues.ticket}
                onChange={(event) => {
                  let ticketDetail = JSON.parse(event.target.value)
                  const errors = {};

                  if (ticketDetail && ticketDetail?.capacity != undefined && ticketDetail?.ticketsBooked && ticketDetail.ticketsBooked.ticketsBookedConfirmed != undefined && parseInt(ticketDetail.capacity) <= parseInt(ticketDetail.ticketsBooked.ticketsBookedConfirmed)) {
                    errors.ticket = t("myEvents.reachedItsMaxCapacity");
                  } else if (formValues.quantity && ticketDetail && ticketDetail?.capacity != undefined && ticketDetail?.ticketsBooked && ticketDetail.ticketsBooked.ticketsBookedConfirmed != undefined && parseInt(ticketDetail.capacity) <= parseInt(parseInt(ticketDetail.ticketsBooked.ticketsBookedConfirmed) + parseInt(formValues.quantity))) {
                    errors.ticket = t("myEvents.reachedItsMaxCapacity");
                  }


                  setFormErrors({ ...errors });
                  if (Object.keys(errors).length > 0) {
                    // addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
                    return false;
                  }

                  setFormValues((prevValues) => ({
                    ...prevValues,
                    ticket: event.target.value,
                  }));
                }}
                errors={formErrors} />

              <TwInputGroup
                label={t("myEvents.quantity")}
                name={"quantity"}
                placeholder={t("myEvents.quantity")}
                // leftIcon={(<img className={""} src={institute_img} alt={""} />)}
                value={formValues.quantity}
                onChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    quantity: e.target.value,
                  }));
                }}
                errors={formErrors}
              />

              <TwInputGroup
                label={t("inputFieldsTitle.fullName")}
                name={"consumerFullname"}
                placeholder={t("inputFieldsTitle.fullName")}
                // leftIcon={(<img className={""} src={institute_img} alt={""} />)}
                value={formValues.consumerFullname}
                onChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    consumerFullname: e.target.value,
                  }));
                }}
                errors={formErrors}
              />

              <TwInputGroup
                label={t("inputFieldsTitle.email")}
                placeholder={t("inputFieldsTitle.email")}
                name={"consumerEmail"}
                value={formValues?.consumerEmail}
                onChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    consumerEmail: e.target.value,
                  }));
                }}
                errors={formErrors}
              />

              <TwPhoneInputGroup
                label={t("inputFieldsTitle.mobileNumber")}
                placeholder={t("inputFieldsTitle.mobileNumber")}
                name={"mobile"}
                value={formValues.mobile}
                country={"nl"}
                onChange={(phone, country, e) => {
                  const numberWithoutDialCode = phone.split("");
                  for (let i = 0; i < country.dialCode.length; i++) {
                    numberWithoutDialCode.shift();
                  }
                  let dialCode = country.dialCode;
                  if (
                    country.format.includes("+") &&
                    !country.dialCode.includes("+")
                  ) {
                    dialCode = "+".concat(country.dialCode);
                  }
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    formattedPhoneNumber: e.target.value,
                    mobile: e.target.value,
                    consumerUsername: dialCode + numberWithoutDialCode.join(""),
                    // mobile: numberWithoutDialCode.join(""),
                  }));
                }}
                errors={formErrors}
              />


            </div>
            <div className="mt-5 sm:mt-4 flex flex-col gap-3 sm:flex-row-reverse ">
              <TwButton
                variant={"secondary"}
                className="w-full sm:w-auto"
                disabled={loadingReduxState.actionLoading}
                actionLoading={(loadingReduxState.actionLoading)}
                onClick={async () => {
                  if (validateData()) {
                    await orderPlace();
                  }
                }}
              >
                {t("myEvents.issueTicket")}
              </TwButton>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
